import { apiSlice } from "./apiSlice";
import {
  ClassroomOption,
  PaginatedClassroomOptionsResponse,
} from "../../services/classrooms/classrooms.types";

export interface GetClassroomsPaginatedArgs {
  page: number;
  pageSize: number;
  search?: string;
  id?: number;
}

export interface ClassroomsPage {
  data: ClassroomOption[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
  };
}

// SCRUM-1095: listado paginado/buscable de grupos, de cualquier escuela.
// Solo lectura (no hay mutaciones sobre este endpoint), así que no declara
// tags de invalidación.
export const classroomsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getClassroomsPaginated: builder.query<
      ClassroomsPage,
      GetClassroomsPaginatedArgs
    >({
      query: ({ page, pageSize, search, id }) => ({
        url: "/classrooms/paginated",
        method: "GET",
        params: {
          page,
          pageSize,
          ...(search && { search }),
          ...(id !== undefined && { id }),
        },
      }),
      transformResponse: (
        response: PaginatedClassroomOptionsResponse,
      ): ClassroomsPage => ({
        data: response.data,
        pagination: {
          page: response.page,
          pageSize: response.pageSize,
          total: response.total,
        },
      }),
    }),
  }),
});

export const { useGetClassroomsPaginatedQuery } = classroomsApi;
